// @flow
import React from 'react'
import { any } from 'prop-types'
import styles from './Popup.styl'

export default class Popup extends React.Component {
	static propTypes = {
		service: any,
		close: any
	}

	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}
	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}
	render() {
		const { service, close } = this.props
		return (
			<div className={ styles.background }>
				<div className={ styles.scroll }>
					<div
						onClick={ close }
						className={ styles.close }
					>
						Fechar
					</div>
					<div className={ styles['split-container'] }>
						<div>
							<div className={ styles.popText } dangerouslySetInnerHTML={ { __html: service.description } } />
						</div>
						<div>
							<img src={ service.images ? service.images[0] : null } className={ styles.popImg } />
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/pages/HomePage/components/Speak/Popup.js